export async function streamAI(path, body, onChunk, onDone, onError) {
  try {
    const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}${path}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    if (!res.ok) {
      const data = await res.json().catch(() => ({}));
      onError(data.detail || 'Request failed');
      return;
    }
    const reader = res.body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
      buffer += decoder.decode(value, { stream: true });
      const parts = buffer.split('\n\n');
      buffer = parts.pop();
      for (const part of parts) {
        const line = part.trim();
        if (!line.startsWith('data:')) continue;
        try {
          const evt = JSON.parse(line.slice(5).trim());
          if (evt.t) onChunk(evt.t);
          if (evt.error) onError(evt.error);
          if (evt.done) onDone();
        } catch { /* partial */ }
      }
    }
  } catch {
    onError('Connection failed — please try again.');
  }
}
